/** @format */

import { combineReducers } from '@reduxjs/toolkit';
import { reducer as usersReducer } from 'src/slices/users';
import { reducer as globalReducer } from 'src/slices/global';
import { reducer as privateContentReducer } from 'src/slices/privateContent';
import { reducer as publicContentReducer } from 'src/slices/publicContent';
import { reducer as knowledgeBaseReducer } from 'src/slices/knowledgeBase';
import { reducer as newsReducer } from 'src/slices/news';
import { reducer as eventsReducer } from 'src/slices/events';
import { reducer as topicsReducer } from 'src/slices/topics';
import { reducer as searchReducer } from 'src/slices/search';
import { reducer as tagsReducer } from 'src/slices/tags';
import { reducer as contentEditorReducer } from 'src/slices/contentEditor';
import { reducer as contentsReducer } from 'src/slices/contents';
import { reducer as academyReducer } from 'src/slices/academy';
import { reducer as shopOrdersReducer } from 'src/slices/shopOrders';

const rootReducer = combineReducers({
  users: usersReducer,
  global: globalReducer,
  privateContent: privateContentReducer,
  publicContent: publicContentReducer,
  knowledgeBase: knowledgeBaseReducer,
  news: newsReducer,
  events: eventsReducer,
  topics: topicsReducer,
  search: searchReducer,
  contents: contentsReducer,
  tags: tagsReducer,
  contentEditor: contentEditorReducer,
  academy: academyReducer,
  shopOrders: shopOrdersReducer
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
